import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { AppSettingsService } from 'src/app/settings/services/app-settings.service'
import { VendorService } from '../vendor.service'


export interface Vendor {
  id: string
  activation: boolean
  img: string
  name: string
  creationDate: string
  email?: string
  [key: string]: any
}
@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrl: './vendors.component.scss'
})
export class VendorsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort
  displayedColumns: string[] = ['img', 'name', 'email', 'id', 'creationDate', 'activation', 'actions'];
  dataSource = new MatTableDataSource<Vendor>([])
  private vendorsSub: any
  projectUrl:string=''
  newVendor: Vendor = {
    id: '',
    img: '',
    name: '',
    creationDate: new Date().toLocaleDateString(),
    activation: true
  }

  constructor(private appSettingsService: AppSettingsService, private router: Router, private builderService: BuilderService, public vendor: VendorService, ) {
    this.dataSource.filterPredicate = (data: Vendor, filter: string) => {
    const filterLower = filter.trim().toLowerCase();
    const idStr = data.id?.toString().toLowerCase() || '';
    const nameStr = data.name?.toLowerCase() || '';
    const emailStr = data.email?.toLowerCase() || '';
    const statusStr = data.activation ? 'active' : 'inactive'; // or "enabled/disabled"

  return (
    idStr.includes(filterLower) ||
    nameStr.includes(filterLower) ||
    emailStr.includes(filterLower) ||
    statusStr.includes(filterLower)
  );  
}
  }

  ngOnInit() {
    this.builderService.showUpdateProgress = true
    this.vendorsSub = this.vendor.vendors.subscribe((vendors: Vendor[]) => {
      this.dataSource.data = vendors || []
      this.builderService.showUpdateProgress = false
    })
  }

  goToNewVendor() {
    if (this.vendor.canAddMoreVendors()) {
      this.router.navigate(['/vendors/new-vendor']);
    } else {
      alert(`You can only create up to ${this.vendor.vendorLimitState.value} vendors.`);
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.dataSource.sortingDataAccessor = (data: Vendor, sortHeaderId: string) => {
      if (sortHeaderId === 'id') return data.id || ''
      return (data as any)[sortHeaderId] as string | number
    }
    this.sort.active = 'id'
    this.sort.direction = 'desc'
    this.sort.sortChange.emit()
  }
  
  // Toggle activation and refresh from service
  toggleActivation(vendor: Vendor) {
    const vendorId = vendor.id
    const updatedData: Vendor = {
      ...vendor,
      activation: !vendor.activation
    }
    this.builderService.showUpdateProgress = true
    this.appSettingsService.upsertSettingsByType(String(this.builderService.selectedProject), 'vendor_' + vendorId, { activation: String(updatedData.activation) })
      .then(() => {
        this.vendor.refresh()
        this.builderService.showUpdateProgress = false
      })
      .catch((error: any) => {
        console.error('Error updating activation:', error)
      })
  }

  /** Text filter across ID/Name (if you keep it) */
  applyFilter(event: Event) {
    this.builderService.showUpdateProgress = true
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage()
    }
    this.builderService.showUpdateProgress = false

  }

  deleteVendor(vendor: Vendor) {
    const ok = confirm(`You are about to delete vendor "${vendor.name}" (ID: ${vendor.id}). This action cannot be undone. Continue?`);
    if (!ok) return;

    this.builderService.showUpdateProgress = true;
    const path = 'projects/' + this.builderService.selectedProject + '/vendors/' + vendor.id;

    this.appSettingsService.upsertSettingsByType(String(this.builderService.selectedProject), 'vendor_' + vendor.id, { deleted: 'true' })
      .then(() => {
        this.vendor.refresh(); // table updates via your subscription
        this.builderService.showUpdateProgress = false;
      })
      .catch((error: any) => {
        console.error('Error deleting vendor:', error);
        this.builderService.showUpdateProgress = false;
      });
  }


      /**
   *  navigate To Vendor 
   * @param projectId
   */
  navigateToVendor = (projectId: any) => {
    localStorage.setItem('selectedProject', projectId)

    this.router.navigate(['/']).then(() => {
      window.location.reload()
    })
  }
}
